<template>
<div class="">
    <PageBreadcrumb :pagetitle="info.title"/>
    <!-- Events -->
    <section class="articlesec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="calendar-full">
                        <div class="row mb-5">
                            <div class="col-12 col-md-7">
                                <div id="pnlSimpleCalendar"><datepicker :inline="true"></datepicker></div>
                            </div>
                            <div class="col-12 col-md-5">
                                <div class="calendarright shrink-effect gradient-bt">
                                    <img src="https://api.fifmi.org.au/sites/default/files/styles/event_thumbnail/public/default_images/article_0.png?itok=rMdG8L4y" class="img-fluid w-100" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="event-block d-flex flex-wrap" v-for="event in events" :key="event.nid">
                        <div class="eventimg shrink-effect gradient-bt">
                            <img v-bind:src="event.field_basic_image" class="img-fluid w-100" alt="" />
                        </div>
                        <div class="event-content align-self-center" >
                            <a href="#"><h5>{{ event.body }}</h5></a>
                            <div class="mb-3">
                                <div class="event-detail">
                                    <i class="fa fa-clock-o pr-1"></i> {{ event.field_single_day_event_date }}
                                </div>
                                <div class="event-address">
                                    <i class="fa fa-map-marker pr-1"></i> {{ event.title }}
                                </div>
                            </div>
                            <a href="#" class="btn btn-outline-primary rounded-50">Join Us</a>
                            <div class="event-date bg-primary text-white float-right text-center p-2">
                                <h2 class="text-white mb-0">{{ event.field_single_day_event_date_1 }}</h2>
                                <span>{{ event.field_single_day_event_date }}</span>
                            </div>
                        </div>
                    </div>
                    <nav>
                        <ul class="pagination mb-0 justify-content-center">
                            <li class="page-item"><router-link class="page-link" to="?page=2">Previous</router-link></li>
                            <li class="page-item active"><router-link class="page-link" to="?page=1">1</router-link></li>
                            <li class="page-item"><router-link class="page-link" to="?page=2">2</router-link></li>
                            <li class="page-item"><router-link class="page-link" to="?page=3">3</router-link></li>
                            <li class="page-item"><router-link class="page-link" to="?page=4">Next</router-link></li>
                        </ul>
                    </nav>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <hr>
                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>
        </div>
    </section>
    <!-- End Events -->
</div>
</template>
<script>
import axios from 'axios';
import PageBreadcrumb from '@/components/PageBreadcrumb';
import LatestNews from "../components/LatestNews";
import SideBarExtras from "../components/SideBarExtras";
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'Events',
    data () {
        return {
            info: { title : "events" },
            events: [],
        }
    },
    components:{
        PageBreadcrumb, LatestNews, SideBarExtras, Datepicker
    },
    mounted() {
        axios
        .get('https://api.fifmi.org.au/api/events')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi')){
                    this.events.push(result.data[i])
                }
            }
        });
    },
}
</script>
